import React, {useCallback, useEffect, useState} from 'react';
import {Box, Tooltip, IconButton} from '@mui/material';
import ResponsiveTypography from '@/components/ui/responsive-typography';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {getTranslatedRole, useTitleStyle} from '@/utils';
import {useTranslation} from 'react-i18next';
import {AccessCode} from '@/types/company';
import {CompanyRole} from '@/constants';

interface AccessCodesProps {
  accessCodes: AccessCode[] | undefined;
}

const AccessCodes: React.FC<AccessCodesProps> = ({accessCodes}) => {
  const {t} = useTranslation();
  const linkStyle = useTitleStyle('34ch', undefined, 'md', false);
  const [copiedLinkCode, setCopiedLinkCode] = useState<string | null>(null);
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [filteredAccessCodes, setFilteredAccessCodes] = useState<AccessCode[]>(
    []
  );

  const handleCopyLinkWithCode = useCallback((code: string) => {
    navigator.clipboard.writeText(code).then(() => {
      setCopiedLinkCode(code);
      setIsLinkCopied(true);
      setTimeout(() => {
        setIsLinkCopied(false);
        setCopiedLinkCode(null);
      }, 2000);
    });
  }, []);

  useEffect(() => {
    if (accessCodes) {
      const filteredCodes = accessCodes.filter((accessCode) =>
        Object.values(CompanyRole).includes(accessCode.role as CompanyRole)
      );
      setFilteredAccessCodes(filteredCodes);
    }
  }, [accessCodes]);
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      justifyContent="center"
      alignItems="center"
      marginTop={2}
      marginBottom={1}
    >
      {accessCodes &&
        filteredAccessCodes.map((accessCode) => (
          <Box
            key={accessCode.code}
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
          >
            <ResponsiveTypography sx={linkStyle} smallerXs>
              <span style={{fontWeight: 'bold'}}>
                {getTranslatedRole(t, accessCode.role as CompanyRole)}
              </span>
              {' - '}
              {accessCode.code}
            </ResponsiveTypography>
            <Tooltip
              title={t('code_copied')}
              placement="top"
              open={isLinkCopied && copiedLinkCode === accessCode.code}
            >
              <IconButton
                onClick={() => handleCopyLinkWithCode(accessCode.code)}
              >
                {copiedLinkCode === accessCode.code ? (
                  <CheckIcon />
                ) : (
                  <ContentCopyIcon />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        ))}
      {}
    </Box>
  );
};
export default AccessCodes;
